import { useTranslation } from "react-i18next";
import { complexDigitToman, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import ReportPage, { col } from "../../../auxiliary/report/ReportPage";

const EPReport = () => {
	const [t] = useTranslation("global");
	const { queryEPPurchaseDealerByDate } = useDealer();

	return (
		<ReportPage
			title={t("extraPackage.report.title")}
			prefix="ep"
			query={queryEPPurchaseDealerByDate}
			columns={[
				col("نام کاربری", "username"),
				col("شماره", "msisdn"),
				col("عنوان بسته", "packageName", { wrap: true }),
				col("قیمت (تومان)", "price"),
				col("سودفروش (تومان)", "commission"),
				col("تاریخ خرید", "purchaseDate"),
				col("وضعیت", "status"),
			]}
			toRow={(item) => ({
				username: item.username,
				msisdn: item.msisdn,
				packageName: item.productname,
				price: complexDigitToman(item.chargamount),
				commission: complexDigitToman(item.commision),
				purchaseDate: convertToJalaliWithoutTime(item.purchasedate),
				status: item.state,
			})}
			excel={{ sheet: "گزارشات فروش بسته", file: "package-sales-report.xlsx" }}
			pickerProps={{ readOnly: true }}
		/>
	);
};

export default EPReport;
